import NotFound from "../components/Error/NotFound/404";
import notFoundRoute from "./not-found.route";
import RetosDashboard from "../pages/Colaborator/retosBi";
import RecompensasMensuales from "../pages/Colaborator/recompensas";
import Prizes from "../pages/Colaborator/prizes";
import TesterRecompensas from "../pages/Tester";
import FinancialTest from "../pages/Tester/QuestionTest";

const colaboratorsRoutes = [
  {
    path: "/",
    component: <RetosDashboard />,
    exact: true,
  },
  {
    path: "/recompensas/:monthNumber",
    component: <RecompensasMensuales />,
    exact: true,
  },
  {
    path: "/prizes/:monthNumber",
    component: <Prizes />,
    exact: true,
  },
  {
    path: "/prizes",
    component: <Prizes />,
    exact: true,
  },
  {
    path: "/404",
    component: <NotFound />,
  },
  {
    path: "/tester",
    component: <TesterRecompensas />,
  },
  {
    path: "/questions-test",
    component: <FinancialTest />,
  },
  notFoundRoute,
];

export default colaboratorsRoutes;
